export default __webpack_public_path__ + "static/media/scrollMobImage2.0bad5257.jpg";